import * as React from 'react';
import { SVGProps } from 'react';

const Svg3DP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.5 11.28H15.5L13.6739 14.48H10.3261L8.5 11.28Z'
      stroke='black'
      strokeWidth='0.75'
    />
    <rect x='2' y='6.26514' width='5.5' height='0.75' fill='black' />
    <rect x='16.5' y='6.26514' width='5.5' height='0.75' fill='black' />
    <rect
      x='7.5'
      y='2'
      width='9'
      height='9.28'
      stroke='black'
      strokeWidth='0.75'
    />
    <path d='M12.52 14.8V18.96H4.52002' stroke='black' strokeWidth='0.75' />
    <line
      x1='4.52002'
      y1='20.5049'
      x2='19.24'
      y2='20.5049'
      stroke='black'
      strokeWidth='0.75'
    />
    <line
      x1='4.52002'
      y1='22.105'
      x2='19.24'
      y2='22.105'
      stroke='black'
      strokeWidth='0.75'
    />
  </svg>
);

export default Svg3DP;
